export function requireConfirmedEnrollmentStatus(status) {
  if (!status || status.skipped || (!status.id && !status.studentExternalId)) {
    const error = new Error('A gravação de contrato, pagamento e uso de imagem não foi confirmada. Recarregue os dados e tente novamente. Se persistir, solicite a verificação do armazenamento à equipe de suporte.');
    error.code = 'ENROLLMENT_STATUS_NOT_SAVED';
    throw error;
  }
  return status;
}
